import React from "react";
import { Link } from "react-router-dom";
import QRCode from "qrcode.react";
import authService from "../../services/authService";
import assessmentLocalStoregService from "../../services/assessmentLocalStoreg";

const History = (props) => {
  const data = assessmentLocalStoregService.getAnswerNormal();
  console.log(data);
  const handlerDelterAndGetAsssessment = async () => {
    try {
      await assessmentLocalStoregService.deleteAnswer();
      props.history.push(`/survey/wellcome`);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="app-pages">
        <i
          style={{ fontSize: "32px", marginLeft: "18px", marginBottom: "15px" }}
          class="material-icons dp48"
          onClick={() => {
            window.history.back();
            return false;
          }}
        >
          arrow_back
        </i>
        <div className="had-container">
          <div className="survey-section">
            <div className="center">
              <p className="left">
                You don't appear to have symptoms of COVID-19.
              </p>
              <QRCode
                value={`${window.location.origin}/?result=${window.btoa(
                  JSON.stringify(data)
                )}`}
              />
            </div>
          </div>
          <div className="row center" style={{ paddingTop: "100px" }}>
            <button
              onClick={handlerDelterAndGetAsssessment}
              className="waves-effect waves-light survey-welcome-button"
            >
              {" "}
              Retake Assessment{" "}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default History;
